import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={29}
    height={29}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m13.292 23.748-1.397-1.26a161 161 0 0 1-4.59-4.34q-1.836-1.82-2.917-3.237-1.082-1.418-1.527-2.593a6.7 6.7 0 0 1-.445-2.38q0-2.305 1.567-3.867 1.566-1.563 3.871-1.563 1.595 0 2.99.816 1.397.815 2.448 2.372 1.05-1.557 2.446-2.372a5.83 5.83 0 0 1 2.991-.816q2.098 0 3.562 1.305a5.43 5.43 0 0 1 1.79 3.25h-1.244Q22.55 7.575 21.4 6.646q-1.15-.93-2.67-.93-1.47 0-2.67.831-1.2.83-2.282 2.516h-.971q-1.099-1.709-2.304-2.527a4.6 4.6 0 0 0-2.648-.82q-1.769 0-2.999 1.205T3.625 9.94q0 1.02.423 2.07t1.51 2.418 2.96 3.211q1.874 1.844 4.773 4.474a618 618 0 0 0 1.82-1.647 85 85 0 0 0 1.599-1.487l.132.132.299.299.298.298.133.133q-.711.674-1.587 1.46-.877.787-1.778 1.621zm8.132-3.81v-3.625H17.8v-1.209h3.625V11.48h1.209v3.625h3.625v1.209h-3.625v3.625z"
      fill="#000"
    />
  </svg>
);
export default SVGComponent;
